<page-loading-spinner [initialized]="initialized"></page-loading-spinner>
<div class="root">
  <h1 *ngIf="initialized">{{'companyClient.account.settings' | translate}}</h1>
  <change-profile (afterInitialized)="onChildInitialized()"></change-profile>
  <mat-divider class="space-top"></mat-divider>
  <change-password *ngIf="initialized"></change-password>
</div>
